export default __webpack_public_path__ + "static/media/playlist-icon.8dd12665.svg";